import React from 'react'
import { SecretField } from '../../../../shared/secret/secret-field'
import '../../../../shared/sso-workspace/auth-card.scss'

// One secret per row, masked until Show (shared/secret): Copy copies the real
// value, and when the browser refuses the secret is revealed and selected.
const SecretRow = ({ label, value }) =>
  <div className="mb-2">
    <div className="sw-label">{label}</div>
    <SecretField value={value} noun={label} testId="alert-secret" valueClassName="ak-secret-value sw-mono ar-secret" />
  </div>

// A generated secret (a webhook's signing secret), shown once (spec §12.4,
// §20.2). Used by the route editor's inline target and the target drawer.
// The caller blocks leaving until "I've copied it" (onConfirm).
export const SecretPanel = ({ secrets, labelOf = k => k, rotated, onConfirm }) =>
  <div className="sw-notice warn ar-secret-panel" role="status">
    <div>
      <p className="fw-semibold">Copy it now: it won't be shown again.{rotated ? ' The old secret keeps signing for 24 hours.' : ''}</p>
      {Object.entries(secrets).map(([k, v]) => <SecretRow key={k} label={labelOf(k)} value={v} />)}
      <button type="button" className="btn sw-btn btn-sm" onClick={onConfirm}>I've copied it</button>
    </div>
  </div>
